/**
 * This component displays a CTA to sign up with EverList.
 */
import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
  theme => ({
    root: {
      backgroundColor: theme.palette.info.light,
      borderRadius: theme.spacing(0.5),
      fontWeight: theme.typography.fontWeightMedium,
      margin: theme.spacing(-0.75, 0, 0), // For mobile screens, we need to nudge the CTA upward slightly.
      padding: theme.spacing(0.5, 2, 0.625),
      textAlign: 'center',

      [theme.breakpoints.up('md')]: {
        margin: 0
      }
    }
  }),
  {
    name: 'EverListCta'
  }
)

const EverListCta = props => {
  const classes = useStyles(props)
  return (
    <span className={classes.root}>
      Sign up with our partner{' '}
      <a
        href="https://everlist.me/account/register?utm_source=zoodiker&utm_medium=email&utm_campaign=list1"
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>EverList</strong>
      </a>
      ! Join now and list your favorite films! Win an exclusive Zoodiker raffle!
    </span>
  )
}

export default EverListCta
